module.exports = __webpack_public_path__ + "img/28.d4bf5a74.jpg";